module.exports = __webpack_public_path__ + "static/media/alert-question.53fd2cd3.svg";